<template>
  <div class="container">
    <div class="top_title">
      <router-link class="icon_back" :to="{path:'/H400062/' + backId}" tag="span"></router-link>
      {{info.I_TITLE}}
    </div>
    <!--<div class="scroll_area">-->
      <div class="videoArea">
        <div>
          <video width="100%" height="100%"  id="video" :src="info.I_VIDEO_QNY"
                 controls="controls"  webkit-playsinline="true" playsinline=""  x5-playsinline="" x-webkit-airplay="allow"
                 :poster="info.I_ICON_QNY" ></video >
        </div>

        <div class="videoInfo">
          <!--<span class="title">{{info.I_TITLE}}</span>-->
          <span class="num">播放&nbsp;&nbsp;{{info.I_PLAY_NUM}}</span>

          <div style="display: flex;justify-content: flex-end"><span style="line-height: 2.6rem;color: #000;font-size: 0.9rem;">赞</span><span class="icon_dz" :class="{active: info.I_UPVOTE_FLAG == 'Y'}" @click="dianZan"></span></div>
        </div>
      </div>
      <div class="clear1"></div>
      <div class="favoriteVideos">
        <p class="favoriteVideos_title">猜你喜欢</p>

        <div v-if="info.dataList.length > 0" class="weui-grids" style="overflow-y: auto">
          <div v-for="item,index in info.dataList" class="weui-grid" :key="index" @click="playVideo(item.I_VIDEO_NO_SYS)">
            <img :src="item.I_ICON_QNY" />
            <p class="title" style="-webkit-box-orient: vertical;">{{item.I_TITLE}}</p>
            <img class="icon_play" src="../assets/images/icon_play1.jpg" alt="">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {
          I_VIDEO_QNY:"",
          I_VIDEO_NO_SYS: "",
          dataList: [],
          backId: ""
        },
      }
    },
    created() {
      this.backId = window.localStorage.getItem("H400062")
      let H400063Info = window.localStorage.getItem("H400063")
      if(H400063Info) {
        window.localStorage.setItem("H400063", H400063Info)
      } else {
        H400063Info = window.localStorage.getItem("H400063")
      }
      this.info.I_VIDEO_NO_SYS = H400063Info
      this.init(H400063Info)
    },
    methods: {
      init(id) {
        let vm = this
        let param = {
          I_VIDEO_NO_SYS: id
        }
        DataRequestFactory.I4000631(param).then((response) => {
          this.info = response

          this.info.I_VIDEO_QNY = response.I_VIDEO_QNY

        })
      },
      dianZan() {
        let param = {
          I_VIDEO_NO_SYS: this.info.I_VIDEO_NO_SYS
        }
        DataRequestFactory.I4000632(param).then((response) => {
          this.info.I_UPVOTE_FLAG = response.I_UPVOTE_FLAG
        })
      },
      playVideo(id) {
        // this.init(id)
        window.localStorage.setItem("H400063", id)
        // this.$router.go(0)
        location.reload()
      }
    },
    mounted() {
      // let screenHeight = window.innerHeight;
      // let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      // let heightDiff = screenHeight - parseInt(fontSize) * 4
      // $("#video").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H400063.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H400063.vue